import React from "react";
import { Mic } from "lucide-react";
import { NEWS_TICKER } from "../lib/site";

export default function NewsTicker() {
  const items = [...NEWS_TICKER, ...NEWS_TICKER];
  return (
    <div className="flex items-stretch bg-[#0f2340] text-white text-[13px] overflow-hidden" data-testid="news-ticker">
      <div className="relative z-10 flex items-center gap-1 pl-3 pr-4 bg-[#0b1a30] font-semibold shrink-0
                      after:content-[''] after:absolute after:right-0 after:top-0 after:h-full after:w-3 after:bg-[#0b1a30] after:[clip-path:polygon(0_0,100%_50%,0_100%)] after:translate-x-full">
        <Mic className="h-3.5 w-3.5" /> News
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="ticker-track flex items-center gap-10 whitespace-nowrap h-full pl-6">
          {items.map((n, i) => (
            <span key={i} className="inline-flex items-center gap-2">
              <span className="rounded-sm bg-[#1c4f8f] px-1.5 py-0.5 text-[11px] font-bold">{n.date}</span>
              <span className="text-[#cfe1ff]">{n.text}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
